<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      机场北站<br>
站点介绍<br>
机场北站位于宝安区机场在建T4航站楼北侧，平行11号线机场北站、穗深城际铁路，车站主体呈南北走向，北接国展南站。 机场北站是11号线与20号线的换乘站，车站色彩基调以淡青色为主，艺术设计理念为“望境”，造型如水流般汇聚在一起，寓意人与信息、金融等的汇聚、交流，又如时空隧道，望向其中，展望未来，有如梦如幻之境。车站为地下三层结构，地下一层为站厅层，地下二层为设备层，地下三层为站台层，站台形式为岛式站台。车站共设有4个出入口（含11号线），接驳穗深城际铁路、在建中的T4航站楼。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分钟	6分32秒<br>
碧头	06:25	00:09	11号线	4分钟	6分32秒<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分34秒	6分钟<br>
碧头	06:25	00:09	11号线	4分34秒	6分钟<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:05	23:58	11号线	4分37秒	6分钟<br>
碧头	06:25	00:09	11号线	4分37秒	6分钟<br>
机场北站	－	－	20号线	7分钟	9分钟-13分26秒<br>
会展城站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br><br>

站点出口信息<br><br>
D出入口:<br>
施工工地（建设中）<br><br>
E出入口:<br>
施工工地（建设中）<br>
公交换乘信息<br><br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "ershihaoxian",
            title: "20号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>